import _ from 'lodash'

import {
  cumsum,
  lowerbound,
  next_power_of_two,
  gcd,
  justification_enum,
} from '@/utils.js'

// *****************************************************************************

const max_scrollbar_precision = 512 * 1024

// *****************************************************************************

class vue_lazy_scroller_logic_base {
  constructor(render, element_size, nb_elements) {
    this.render = render
    this.element_size = element_size
    this.nb_elements = nb_elements

    this.variable_size_start_pos = undefined
    this.variable_sizes = undefined
    this.display_pos_start = 0
    this.display_pos_stop = 0

    this.scale = 1
    this.effective_display_size_start = 0
    this.effective_display_size_stop = 0
    this.theoretical_total_size = 0
    this.effective_total_size = 0
    this.theoretical_cumulated_variable_size_start = undefined
    this.cumulated_variable_size_start_pos = undefined
    this.cumulated_variable_sizes = undefined

    this.container_element = undefined
    this.current_pos = 0
    this.current_pos_scroll = 0
    this.forced_scroll = 0

    this.handle_scroll = _.debounce(this.do_handle_scroll.bind(this), 100, {
      leading: false,
      trailing: true,
    })
  }
  initialize(container_element, test_element) {
    this.container_element = container_element

    if (_.isUndefined(this.element_size) || this.element_size === 0) {
      this.element_size = Math.ceil(this.get_element_size(test_element))
    }

    if (!_.isUndefined(this.element_size) && this.element_size !== 0) {
      this.synchronize()
      this.relayout()
    }
    return this.element_size
  }
  get_nb_elements() {
    return this.nb_elements
  }
  set_nb_elements(nb_elements) {
    this.nb_elements = nb_elements
    this.synchronize()
  }
  set_variable_size_start_pos(variable_size_start_pos) {
    this.variable_size_start_pos = variable_size_start_pos
    this.synchronize()
  }
  set_variable_sizes(variable_sizes) {
    this.variable_sizes = variable_sizes
    this.synchronize()
  }
  set_display_range(display_pos_start, display_pos_stop) {
    this.display_pos_start = display_pos_start
    this.display_pos_stop = display_pos_stop
    this.synchronize()
  }
  synchronize() {
    let scale = 1
    let effective_display_size_start = 0
    let effective_display_size_stop = 0
    let theoretical_total_size = 0
    let effective_total_size = 0
    let theoretical_cumulated_variable_size_start = undefined
    let cumulated_variable_size_start_pos = undefined
    let cumulated_variable_sizes = undefined

    const element_size = this.element_size
    const nb_elements = this.get_nb_elements()
    if (!_.isUndefined(element_size) && !_.isUndefined(nb_elements)) {
      theoretical_total_size = element_size * nb_elements
      scale = 1
      if (theoretical_total_size > max_scrollbar_precision) {
        scale = Math.ceil(theoretical_total_size / max_scrollbar_precision)
      }
      const nb_displayed_elements =
        this.display_pos_stop - this.display_pos_start
      effective_total_size =
        element_size *
        (nb_displayed_elements + (nb_elements - nb_displayed_elements) / scale)
      effective_display_size_start =
        (this.display_pos_start * element_size) / scale
      effective_display_size_stop =
        effective_display_size_start + nb_displayed_elements * element_size

      if (
        !_.isUndefined(this.variable_size_start_pos) &&
        !_.isUndefined(this.variable_sizes) &&
        this.variable_sizes.length > 0
      ) {
        const variable_sizes_start =
          Math.max(this.variable_size_start_pos, this.display_pos_start) -
          this.variable_size_start_pos
        const variable_sizes_stop =
          Math.min(
            this.variable_size_start_pos + this.variable_sizes.length,
            this.display_pos_stop
          ) - this.variable_size_start_pos
        if (variable_sizes_start < variable_sizes_stop) {
          cumulated_variable_size_start_pos =
            this.variable_size_start_pos + variable_sizes_start
          theoretical_cumulated_variable_size_start =
            cumulated_variable_size_start_pos * element_size
          cumulated_variable_sizes = cumsum(
            this.variable_sizes.slice(variable_sizes_start, variable_sizes_stop)
          )
          const size_diff =
            cumulated_variable_sizes[cumulated_variable_sizes.length - 1] -
            cumulated_variable_sizes.length * element_size
          effective_display_size_stop += size_diff
          theoretical_total_size += size_diff
          effective_total_size += size_diff
        }
      }
    }
    this.scale = scale
    this.effective_display_size_start = effective_display_size_start
    this.effective_display_size_stop = effective_display_size_stop
    this.theoretical_total_size = theoretical_total_size
    this.effective_total_size = effective_total_size
    this.theoretical_cumulated_variable_size_start = theoretical_cumulated_variable_size_start
    this.cumulated_variable_size_start_pos = cumulated_variable_size_start_pos
    this.cumulated_variable_sizes = cumulated_variable_sizes
    // console.log(
    //   'element_size',
    //   element_size,
    //   'nb_elements',
    //   nb_elements,
    //   'variable_size_start_pos',
    //   this.variable_size_start_pos,
    //   'variable_sizes',
    //   this.variable_sizes,
    //   'display_pos_stop',
    //   this.display_pos_stop,
    //   'display_pos_start',
    //   this.display_pos_start,
    //   'scale',
    //   scale,
    //   'effective_display_size_start',
    //   effective_display_size_start,
    //   'effective_display_size_stop',
    //   effective_display_size_stop,
    //   'theoretical_total_size',
    //   theoretical_total_size,
    //   'effective_total_size',
    //   effective_total_size,
    //   'theoretical_cumulated_variable_size_start',
    //   theoretical_cumulated_variable_size_start,
    //   'cumulated_variable_size_start_pos',
    //   cumulated_variable_size_start_pos,
    //   'cumulated_variable_sizes',
    //   cumulated_variable_sizes
    // )
  }
  theoretical_scroll_to_pos(scroll) {
    let used_scroll = scroll
    const element_size = this.element_size
    let res = 0
    if (!_.isUndefined(element_size)) {
      if (
        !_.isUndefined(this.theoretical_cumulated_variable_size_start) &&
        used_scroll > this.theoretical_cumulated_variable_size_start
      ) {
        const offset =
          used_scroll - this.theoretical_cumulated_variable_size_start
        const total_variable_size = this.cumulated_variable_sizes[
          this.cumulated_variable_sizes.length - 1
        ]
        if (offset >= total_variable_size) {
          used_scroll +=
            this.element_size * this.cumulated_variable_sizes.length -
            total_variable_size
          res = Math.floor(used_scroll / element_size)
        } else {
          res =
            lowerbound(this.cumulated_variable_sizes, offset) +
            this.cumulated_variable_size_start_pos
        }
      } else {
        res = Math.floor(used_scroll / element_size)
      }
    }
    return res
  }
  effective_scroll_to_pos(scroll) {
    let used_scroll = scroll
    const scale = this.scale
    if (used_scroll < this.effective_display_size_start) {
      used_scroll *= scale
    } else {
      let to_add = this.effective_display_size_start
      if (used_scroll > this.effective_display_size_stop) {
        to_add += used_scroll - this.effective_display_size_stop
      }
      used_scroll += to_add * (scale - 1)
    }
    const res = this.theoretical_scroll_to_pos(used_scroll)
    return res
  }
  theoretical_pos_to_scroll(pos) {
    const element_size = this.element_size
    let res = 0
    if (!_.isUndefined(element_size)) {
      if (
        !_.isUndefined(this.cumulated_variable_size_start_pos) &&
        pos > this.cumulated_variable_size_start_pos
      ) {
        const offset = pos - this.cumulated_variable_size_start_pos
        if (offset >= this.cumulated_variable_sizes.length) {
          const total_variable_size = this.cumulated_variable_sizes[
            this.cumulated_variable_sizes.length - 1
          ]
          res = (pos - this.cumulated_variable_sizes.length) * element_size
          res += total_variable_size
        } else {
          res =
            this.theoretical_cumulated_variable_size_start +
            this.cumulated_variable_sizes[offset - 1]
        }
      } else {
        res = pos * element_size
      }
    }
    return res
  }
  effective_pos_to_scroll(pos) {
    const element_size = this.element_size
    const display_pos_start = this.display_pos_start
    const display_pos_stop = this.display_pos_stop
    const scale = this.scale

    let res = this.theoretical_pos_to_scroll(pos)
    if (pos < display_pos_start) {
      res = res / scale
    } else {
      res += display_pos_start * element_size * (1 / scale - 1)
      if (pos > display_pos_stop) {
        res += (pos - display_pos_stop) * element_size * (1 / scale - 1)
      }
    }
    return res
  }
  do_handle_scroll() {
    // When user scrolls or scroll is forced programatically
    this.relayout()
  }
  relayout() {
    const [current_scroll_pos_start, viewport_size] = this.get_viewport_info()
    this.recompute_display_range(current_scroll_pos_start, viewport_size)
  }
  recompute_display_range(current_scroll_pos_start, viewport_size) {
    // console.log('recompute_display_range')

    if (viewport_size === 0) {
      return
    }
    // *************************************************************************
    // Fetches constants
    // *************************************************************************

    const nb_elements = this.get_nb_elements()
    const scale = this.scale
    const theoretical_total_size = this.theoretical_total_size
    let effective_total_size = this.effective_total_size

    // *************************************************************************
    // Computes scroll update if the variable_sizes information changes
    // *************************************************************************

    const real_scroll = current_scroll_pos_start
    const old_pos = this.current_pos
    const new_pos_scroll = this.effective_pos_to_scroll(this.current_pos)
    if (new_pos_scroll !== this.current_pos_scroll) {
      const delta = new_pos_scroll - this.current_pos_scroll
      this.forced_scroll += delta
    }
    current_scroll_pos_start += this.forced_scroll

    // console.log(
    //   this.current_pos,
    //   this.current_pos_scroll,
    //   new_pos_scroll,
    //   this.forced_scroll,
    //   current_scroll_pos_start,
    //   viewport_size
    // )

    // *************************************************************************
    // Computes the new size / coordinates given the position
    // *************************************************************************

    // effective_pos is the start of the viewport
    let effective_pos, theoretical_start_scroll, theoretical_stop_scroll
    const scroll_upward =
      current_scroll_pos_start < this.effective_display_size_start
    const scroll_downward =
      current_scroll_pos_start > this.effective_display_size_stop
    let used_current_pos

    if (!scroll_downward) {
      used_current_pos = this.effective_scroll_to_pos(current_scroll_pos_start)
      effective_pos = used_current_pos
      const theoretical_scroll = this.theoretical_pos_to_scroll(
        used_current_pos
      )

      theoretical_start_scroll = Math.max(theoretical_scroll - viewport_size, 0)
      theoretical_stop_scroll = Math.min(
        theoretical_scroll + 2 * viewport_size,
        theoretical_total_size
      )
    } else {
      used_current_pos = this.effective_scroll_to_pos(
        current_scroll_pos_start + viewport_size
      )
      const theoretical_scroll = this.theoretical_pos_to_scroll(
        used_current_pos
      )
      effective_pos = this.theoretical_scroll_to_pos(
        theoretical_scroll - viewport_size
      )

      theoretical_start_scroll = Math.max(
        theoretical_scroll - 2 * viewport_size,
        0
      )
      theoretical_stop_scroll = Math.min(
        theoretical_scroll + viewport_size,
        theoretical_total_size
      )
    }

    const theoretical_start_pos = this.theoretical_scroll_to_pos(
      theoretical_start_scroll
    )
    const theoretical_stop_pos = this.theoretical_scroll_to_pos(
      theoretical_stop_scroll
    )

    let effective_scroll = this.effective_pos_to_scroll(effective_pos)

    const rounded_start_pos = Math.floor(theoretical_start_pos / scale) * scale
    let rounded_stop_pos =
      Math.floor(theoretical_stop_pos / scale) * scale + (nb_elements % scale)
    if (rounded_stop_pos < theoretical_stop_pos) {
      rounded_stop_pos += scale
    }

    // *************************************************************************
    // Recomputes the display information after display range synchronization
    // *************************************************************************

    // console.log(
    //   'Switching display_pos',
    //   this.display_pos_start,
    //   this.display_pos_stop,
    //   'to',
    //   rounded_start_pos,
    //   rounded_stop_pos
    // )

    this.set_display_range(rounded_start_pos, rounded_stop_pos)
    effective_total_size = this.effective_total_size

    const before_padding = this.effective_pos_to_scroll(theoretical_start_pos)
    const padding_and_size = this.effective_pos_to_scroll(theoretical_stop_pos)
    this.render.padding_low = before_padding
    this.render.component_start = theoretical_start_pos
    this.render.padding_high = effective_total_size - padding_and_size
    this.render.component_stop = theoretical_stop_pos
    this.render.really_rendered_size = padding_and_size - before_padding

    let delta
    const post_current_pos_scroll = this.effective_pos_to_scroll(
      used_current_pos
    )
    if (scroll_upward) {
      delta = post_current_pos_scroll - current_scroll_pos_start
    } else if (scroll_downward) {
      delta = post_current_pos_scroll - current_scroll_pos_start - viewport_size
    } else {
      delta = post_current_pos_scroll - effective_scroll
    }

    // console.log(
    //   'delta',
    //   delta,
    //   used_current_pos,
    //   current_scroll_pos_start,
    //   effective_scroll,
    //   post_current_pos_scroll
    // )
    this.forced_scroll += delta

    const natural_delta =
      Math.min(
        Math.max(0, current_scroll_pos_start),
        effective_total_size - viewport_size
      ) - current_scroll_pos_start

    const wanted_scroll = Math.min(
      Math.max(0, current_scroll_pos_start + delta),
      effective_total_size - viewport_size
    )
    this.forced_scroll = wanted_scroll - real_scroll - natural_delta

    this.current_pos = effective_pos
    this.current_pos_scroll = this.effective_pos_to_scroll(effective_pos)
  }
  scroll_to_pos(pos, justification = justification_enum.low) {
    const [current_scroll_pos_start, viewport_size] = this.get_viewport_info()
    // *************************************************************************
    // Fetches constants
    // *************************************************************************

    // const viewport_size = this.viewport_size
    const nb_elements = this.get_nb_elements()
    const scale = this.scale
    const theoretical_total_size = this.theoretical_total_size
    let effective_total_size = this.effective_total_size

    // *************************************************************************
    // Computes the new size / coordinates given the position
    // *************************************************************************

    // effective_pos is the start of the viewport
    // used_current_pos is the reference element used to determine the scrolling
    let effective_pos,
      theoretical_start_scroll,
      theoretical_stop_scroll,
      used_current_pos
    if ((justification & justification_enum.low) !== 0) {
      used_current_pos = pos
      effective_pos = used_current_pos
      const theoretical_scroll = this.theoretical_pos_to_scroll(
        used_current_pos
      )

      theoretical_start_scroll = Math.max(theoretical_scroll - viewport_size, 0)
      theoretical_stop_scroll = Math.min(
        theoretical_scroll + 2 * viewport_size,
        theoretical_total_size
      )
    } else if ((justification & justification_enum.high) !== 0) {
      used_current_pos = Math.min(pos + 1, nb_elements)
      const theoretical_scroll = this.theoretical_pos_to_scroll(
        used_current_pos
      )

      theoretical_start_scroll = Math.max(
        theoretical_scroll - 2 * viewport_size,
        0
      )
      theoretical_stop_scroll = Math.min(
        theoretical_scroll + viewport_size,
        theoretical_total_size
      )

      effective_pos = this.theoretical_scroll_to_pos(
        theoretical_scroll - viewport_size
      )
    } else {
      used_current_pos = pos
      const theoretical_scroll = this.theoretical_pos_to_scroll(
        used_current_pos
      )
      const post_used_current_pos = Math.min(pos + 1, nb_elements)
      const theoretical_post_scroll = this.theoretical_pos_to_scroll(
        post_used_current_pos
      )
      theoretical_start_scroll = Math.max(
        (theoretical_scroll + theoretical_post_scroll) / 2 -
          1.5 * viewport_size,
        0
      )
      theoretical_stop_scroll = Math.min(
        (theoretical_scroll + theoretical_post_scroll) / 2 +
          1.5 * viewport_size,
        theoretical_total_size
      )
      effective_pos = this.theoretical_scroll_to_pos(
        (theoretical_scroll + theoretical_post_scroll) / 2 - 0.5 * viewport_size
      )
    }

    const theoretical_start_pos = this.theoretical_scroll_to_pos(
      theoretical_start_scroll
    )
    const theoretical_stop_pos = this.theoretical_scroll_to_pos(
      theoretical_stop_scroll
    )

    const rounded_start_pos = Math.floor(theoretical_start_pos / scale) * scale
    let rounded_stop_pos =
      Math.floor(theoretical_stop_pos / scale) * scale + (nb_elements % scale)
    if (rounded_stop_pos < theoretical_stop_pos) {
      rounded_stop_pos += scale
    }

    // *************************************************************************
    // Recomputes the display information after display range synchronization
    // *************************************************************************

    this.set_display_range(rounded_start_pos, rounded_stop_pos)
    effective_total_size = this.effective_total_size

    const before_padding = this.effective_pos_to_scroll(theoretical_start_pos)
    const padding_and_size = this.effective_pos_to_scroll(theoretical_stop_pos)
    this.render.padding_low = before_padding
    this.render.component_start = theoretical_start_pos
    this.render.padding_high = effective_total_size - padding_and_size
    this.render.component_stop = theoretical_stop_pos
    this.render.really_rendered_size = padding_and_size - before_padding

    let post_current_pos_scroll
    if ((justification & justification_enum.low) !== 0) {
      post_current_pos_scroll = this.effective_pos_to_scroll(used_current_pos)
    } else if ((justification & justification_enum.high) !== 0) {
      post_current_pos_scroll =
        this.effective_pos_to_scroll(used_current_pos) - viewport_size
    } else {
      const post_used_current_pos = Math.min(pos + 1, nb_elements)
      post_current_pos_scroll =
        (this.effective_pos_to_scroll(used_current_pos) +
          this.effective_pos_to_scroll(post_used_current_pos)) /
          2 -
        0.5 * viewport_size
    }
    this.forced_scroll = post_current_pos_scroll - current_scroll_pos_start

    this.current_pos = effective_pos
    this.current_pos_scroll = this.effective_pos_to_scroll(effective_pos)
  }

  adjust_scroll() {
    if (this.forced_scroll !== 0) {
      const [old_value, viewport_size] = this.get_viewport_info()
      const forced_scroll = this.forced_scroll
      this.scrollto(old_value + forced_scroll)
      this.forced_scroll = 0
    }
  }
}

// *****************************************************************************

export class vue_lazy_scroller_logicx extends vue_lazy_scroller_logic_base {
  get_viewport_info() {
    return [
      this.container_element.scrollLeft,
      this.container_element.clientWidth,
    ]
  }
  scrollto(pos) {
    this.container_element.scrollLeft = pos
  }
  get_element_size(test_element) {
    return test_element.offsetWidth
  }
  replicate(element) {
    element.scrollLeft = this.container_element.scrollLeft
  }
}

export class vue_lazy_scroller_logicy extends vue_lazy_scroller_logic_base {
  get_viewport_info() {
    return [
      this.container_element.scrollTop,
      this.container_element.clientHeight,
    ]
  }
  scrollto(pos) {
    this.container_element.scrollTop = pos
  }
  get_element_size(test_element) {
    return test_element.offsetHeight
  }
  replicate(element) {
    element.scrollTop = this.container_element.scrollTop
  }
}
